export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  categorySlug: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  tags: string[];
  featured: boolean;
  views: number;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    slug: 'gpoint-official-entry-guide',
    title: 'g点网官方入口完整指南：快速访问与安全登录',
    excerpt: '详细介绍g点网官方入口的多种访问方式，包括网页端、移动端及客户端，确保您能够安全便捷地登录平台。',
    content: `<h2>一、g点网官方入口概述</h2><p>g点网作为综合性网络服务平台，为用户提供了多种便捷的访问入口。本文将为各位用户详细介绍g点网官方入口的全部访问方式，帮助您根据自身需求选择最适合的登录途径。</p><h2>二、网页端入口</h2><p>通过浏览器访问g点网官方网站是最常用也是最便捷的方式。用户只需在浏览器地址栏输入官方网址，即可快速进入g点网首页。建议将g点网官方网址添加至浏览器收藏夹，方便日后快速访问。为确保安全，请务必认准官方认证标识，谨防钓鱼网站。</p><h2>三、移动端入口</h2><p>g点网针对移动设备进行了全面适配优化。用户可通过手机浏览器访问移动版网页，享受流畅的触屏操作体验。移动端支持完整的平台功能，包括资讯浏览、账号管理、安全设置等。</p><h2>四、安全登录建议</h2><p>为保障您的账号安全，建议开启双重认证功能，定期修改登录密码，不使用公共网络登录账号。如遇到登录异常，请及时联系官方客服进行处理。</p>`,
    categorySlug: 'usage-guide',
    author: 'g点网运营团队',
    date: '2026-08-01',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20website%20login%20page%20on%20laptop%20screen%20with%20warm%20lighting%20and%20minimalist%20design%2C%20soft%20beige%20background%2C%20professional%20atmosphere%2C%20editorial%20photography%20style%20with%20natural%20warm%20tones%20and%20gentle%20gradients&width=800&height=450&seq=article-official-entry&orientation=landscape',
    tags: ['官方入口', '登录教程', '安全访问'],
    featured: true,
    views: 15820,
  },
  {
    id: 'article-2',
    slug: 'gpoint-core-features-overview',
    title: 'g点网核心功能全解析：一站式掌握平台全部能力',
    excerpt: '全面梳理g点网各项核心功能模块，从基础操作到高级应用，助您充分发挥平台的强大能力。',
    content: `<h2>一、平台功能总览</h2><p>g点网经过多年发展，已构建起一套完整的服务功能体系。本文将系统性地介绍平台的核心功能模块，帮助用户全面了解并高效使用g点网的全部服务能力。</p><h2>二、信息资讯模块</h2><p>g点网信息资讯模块汇聚了海量优质内容，涵盖科技动态、行业趋势、实用教程等多个领域。智能推荐算法会根据您的阅读偏好，精准推送个性化内容。支持内容收藏、历史记录、离线阅读等实用功能。</p><h2>三、社区互动功能</h2><p>平台内置完善的社区互动系统，用户可在文章下方发表评论、参与话题讨论、与其他用户交流心得。社区采用积分激励体系，活跃用户可获得专属权益。</p><h2>四、个人中心</h2><p>个人中心集成了账号管理、隐私设置、消息通知、数据统计等功能。用户可以自定义界面主题、设置内容偏好、管理订阅服务等。</p>`,
    categorySlug: 'feature-tutorial',
    author: 'g点网产品团队',
    date: '2026-07-28',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20dashboard%20interface%20with%20multiple%20feature%20panels%20on%20a%20large%20screen%2C%20warm%20neutral%20color%20scheme%2C%20professional%20SaaS%20product%20design%2C%20soft%20ambient%20lighting%2C%20editorial%20photography%20with%20minimalist%20aesthetic&width=800&height=450&seq=article-core-features&orientation=landscape',
    tags: ['功能介绍', '平台能力', '使用教程'],
    featured: true,
    views: 23450,
  },
  {
    id: 'article-3',
    slug: 'gpoint-account-registration-tutorial',
    title: 'g点网注册登录详细教程：三步完成账号创建',
    excerpt: '手把手教您完成g点网账号注册与登录流程，包含手机号注册、邮箱注册及第三方快速登录方式。',
    content: `<h2>一、注册前准备</h2><p>在开始注册g点网账号之前，请确保您已准备好有效的手机号码或电子邮箱地址。平台支持多种注册方式以满足不同用户的需求。</p><h2>二、手机号注册流程</h2><p>第一步：访问g点网官方入口，点击页面右上角的"注册"按钮。第二步：输入您的手机号码，点击"获取验证码"。第三步：输入收到的短信验证码，设置登录密码和昵称，阅读并同意用户协议后点击"完成注册"。</p><h2>三、邮箱注册流程</h2><p>邮箱注册适用于习惯使用电子邮件的用户。填写邮箱地址后系统会发送验证链接，点击链接完成验证即可激活账号。</p><h2>四、第三方快捷登录</h2><p>为方便用户快速使用，g点网支持微信、QQ等第三方账号一键登录，无需额外注册即可体验平台服务。</p>`,
    categorySlug: 'usage-guide',
    author: 'g点网客服团队',
    date: '2026-07-25',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20registration%20form%20on%20smartphone%20screen%20with%20warm%20lighting%2C%20minimalist%20UI%20design%2C%20soft%20beige%20background%2C%20user-friendly%20interface%2C%20editorial%20photography%20with%20natural%20warm%20tones&width=800&height=450&seq=article-registration&orientation=landscape',
    tags: ['注册教程', '账号创建', '登录方式'],
    featured: true,
    views: 31200,
  },
  {
    id: 'article-4',
    slug: 'gpoint-security-settings-guide',
    title: 'g点网安全设置完全指南：保护您的账号与隐私',
    excerpt: '详细讲解g点网安全中心各项防护功能，包括双重认证、登录保护、隐私设置及异常监控等内容。',
    content: `<h2>一、安全防护的重要性</h2><p>在当今网络安全形势日益严峻的背景下，做好账号安全防护是每位用户的必修课。g点网安全中心提供了全方位的防护方案，帮助用户构建坚实的安全防线。</p><h2>二、双重认证设置</h2><p>双重认证是保护账号安全最有效的措施之一。在g点网中，您可以通过"个人中心 - 安全设置 - 双重认证"路径开启此功能。开启后，每次登录除了输入密码外，还需输入动态验证码。</p><h2>三、登录保护机制</h2><p>g点网配备了智能登录保护系统，当检测到异常登录行为时（如异地登录、新设备登录），系统会自动触发安全验证流程，并向您的注册手机或邮箱发送安全提醒。</p><h2>四、隐私设置指南</h2><p>在隐私设置中，您可以控制个人信息的公开范围，包括个人主页可见性、动态发布权限、搜索索引设置等。建议定期检查并更新隐私设置，确保符合您的使用习惯。</p>`,
    categorySlug: 'security',
    author: 'g点网安全团队',
    date: '2026-07-22',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20security%20concept%20with%20shield%20icon%20and%20lock%20symbols%20on%20dark%20warm%20background%2C%20minimalist%20design%2C%20professional%20atmosphere%2C%20soft%20gradient%20lighting%2C%20editorial%20style&width=800&height=450&seq=article-security&orientation=landscape',
    tags: ['安全设置', '双重认证', '隐私保护'],
    featured: false,
    views: 18900,
  },
  {
    id: 'article-5',
    slug: 'gpoint-latest-update-2026',
    title: 'g点网2026年重大更新：全新界面与功能升级',
    excerpt: 'g点网最新版本发布，带来全新的用户界面设计、性能优化以及多项期待已久的新功能。',
    content: `<h2>一、更新概述</h2><p>2026年，g点网迎来了自上线以来最大规模的一次升级更新。本次更新涵盖了界面设计、性能优化、功能新增等多个方面，旨在为用户提供更加出色的使用体验。</p><h2>二、全新界面设计</h2><p>新版本采用了更加简洁现代的设计语言，优化了信息架构和导航逻辑，使用户能够更直观地找到所需功能。整体配色更加柔和舒适，长时间使用也不会产生视觉疲劳。</p><h2>三、性能大幅提升</h2><p>技术团队对底层架构进行了全面重构，页面加载速度提升超过50%，搜索响应时间缩短至毫秒级，视频播放流畅度显著改善。</p><h2>四、新增功能一览</h2><p>本次更新新增了智能搜索、个性化首页、深色模式、多语言支持等多项用户期待已久的功能。同时优化了社区互动体验，新增了话题标签和内容分组功能。</p>`,
    categorySlug: 'platform-news',
    author: 'g点网技术团队',
    date: '2026-07-20',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20software%20update%20concept%20with%20clean%20interface%20mockup%20on%20laptop%20screen%2C%20warm%20neutral%20color%20palette%2C%20minimalist%20design%20aesthetic%2C%20professional%20tech%20atmosphere%2C%20soft%20natural%20lighting&width=800&height=450&seq=article-update-2026&orientation=landscape',
    tags: ['版本更新', '新功能', '界面升级'],
    featured: true,
    views: 45600,
  },
  {
    id: 'article-6',
    slug: 'gpoint-faq-common-issues',
    title: 'g点网常见问题汇总：快速解决您的使用困惑',
    excerpt: '整理用户最常遇到的20个问题并给出详细解答，涵盖账号、功能、安全、付费等各个方面。',
    content: `<h2>一、账号相关问题</h2><p><strong>Q：忘记密码怎么办？</strong><br/>A：在登录页面点击"忘记密码"，通过绑定的手机号或邮箱接收验证码后即可重置密码。</p><p><strong>Q：可以修改绑定的手机号吗？</strong><br/>A：可以，在个人中心的账号安全页面进行手机号更换操作，需验证原手机号和新手机号。</p><h2>二、功能使用问题</h2><p><strong>Q：如何收藏喜欢的文章？</strong><br/>A：在文章页面点击收藏按钮即可，收藏的文章可在个人中心的收藏夹中查看。</p><p><strong>Q：支持离线阅读吗？</strong><br/>A：支持，在文章页面点击"离线缓存"按钮即可将文章保存至本地。</p><h2>三、安全相关问题</h2><p><strong>Q：账号被盗怎么办？</strong><br/>A：立即联系官方客服冻结账号，通过身份验证后即可恢复账号使用权。</p>`,
    categorySlug: 'faq',
    author: 'g点网客服团队',
    date: '2026-07-18',
    readTime: '15分钟',
    image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20FAQ%20webpage%20design%20with%20question%20and%20answer%20cards%2C%20warm%20minimalist%20layout%2C%20soft%20beige%20background%2C%20friendly%20user%20support%20concept%2C%20editorial%20photography%20with%20natural%20light&width=800&height=450&seq=article-faq-common&orientation=landscape',
    tags: ['常见问题', '故障排除', '客服支持'],
    featured: false,
    views: 56700,
  },
  {
    id: 'article-7',
    slug: 'gpoint-search-tips',
    title: 'g点网高效搜索技巧：快速找到您需要的内容',
    excerpt: '掌握g点网搜索功能的高级用法，学习使用关键词组合、筛选器和排序功能精准定位信息。',
    content: `<h2>一、基础搜索功能</h2><p>g点网内置了强大的全文搜索引擎，用户在首页搜索框或任意页面的搜索栏中输入关键词，即可快速获取相关内容。搜索结果按相关度排序，最新和最匹配的内容会优先展示。</p><h2>二、高级搜索技巧</h2><p>使用引号进行精确匹配搜索，使用减号排除特定词汇，使用site:限定搜索范围。多关键词用空格分隔可实现组合搜索，如需搜索同时包含"安全"和"设置"的内容，输入"安全 设置"即可。</p><h2>三、筛选器使用</h2><p>搜索结果页面提供了丰富的筛选选项，可按时间范围、内容类型、所属分类等维度进行精细化筛选。善用筛选器可以大幅提升信息检索效率。</p>`,
    categorySlug: 'feature-tutorial',
    author: 'g点网产品团队',
    date: '2026-07-15',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20search%20engine%20interface%20concept%20with%20magnifying%20glass%20icon%20and%20clean%20results%20layout%2C%20warm%20neutral%20tones%2C%20minimalist%20design%2C%20professional%20tech%20atmosphere%2C%20editorial%20style&width=800&height=450&seq=article-search-tips&orientation=landscape',
    tags: ['搜索技巧', '高级功能', '效率提升'],
    featured: false,
    views: 12300,
  },
  {
    id: 'article-8',
    slug: 'gpoint-mobile-app-guide',
    title: 'g点网移动端使用全攻略：随时随地畅享服务',
    excerpt: '详细介绍g点网移动端的使用方法，包括界面布局、手势操作、推送通知管理及省流量模式。',
    content: `<h2>一、移动端特色</h2><p>g点网移动端针对手机屏幕进行了深度适配优化，提供与网页端一致的功能体验。界面设计遵循移动端交互规范，操作流畅自然。</p><h2>二、界面布局说明</h2><p>移动端采用底部导航栏设计，包含首页、分类、消息、个人中心四个主要入口。顶部设有搜索栏和快捷功能菜单，方便用户快速访问常用功能。</p><h2>三、手势操作</h2><p>支持右滑返回上级页面、下拉刷新内容列表、长按触发快捷菜单等便捷手势操作。文章阅读页面支持双击点赞和滑动翻页。</p><h2>四、省流量模式</h2><p>在设置中开启省流量模式后，图片将以压缩格式加载，视频自动暂停预加载，有效节省移动数据流量消耗。</p>`,
    categorySlug: 'usage-guide',
    author: 'g点网运营团队',
    date: '2026-07-12',
    readTime: '9分钟',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20showing%20clean%20modern%20app%20interface%20with%20content%20feed%2C%20warm%20lighting%2C%20minimalist%20mobile%20app%20design%2C%20soft%20beige%20background%2C%20editorial%20product%20photography&width=800&height=450&seq=article-mobile-guide&orientation=landscape',
    tags: ['移动端', 'App使用', '操作教程'],
    featured: false,
    views: 8700,
  },
  {
    id: 'article-9',
    slug: 'gpoint-privacy-protection',
    title: 'g点网隐私保护政策解读：您的数据如何被保护',
    excerpt: '深入解读g点网隐私保护政策，了解平台如何收集、使用和保护您的个人信息。',
    content: `<h2>一、隐私保护承诺</h2><p>g点网始终将用户隐私保护置于首位。我们严格遵循相关法律法规，建立了完善的隐私保护体系，确保用户个人信息得到妥善保护。</p><h2>二、信息收集范围</h2><p>平台仅收集提供核心服务所必需的最少信息，包括账号注册信息、使用偏好设置及必要的设备信息。未经用户明确授权，不会收集任何非必要信息。</p><h2>三、数据使用原则</h2><p>收集的信息仅用于改善服务体验、优化产品功能和保障账号安全。g点网承诺不会将用户数据出售或分享给任何第三方机构。</p><h2>四、用户权利</h2><p>用户享有数据访问权、更正权、删除权及数据可携权。如需行使上述权利，可在个人中心提交申请，客服团队将在3个工作日内处理。</p>`,
    categorySlug: 'security',
    author: 'g点网法务团队',
    date: '2026-07-10',
    readTime: '11分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20privacy%20protection%20concept%20with%20document%20and%20shield%20symbols%2C%20warm%20neutral%20color%20palette%2C%20minimalist%20legal%20theme%20design%2C%20professional%20atmosphere%2C%20soft%20natural%20lighting&width=800&height=450&seq=article-privacy&orientation=landscape',
    tags: ['隐私政策', '数据保护', '用户权益'],
    featured: false,
    views: 14500,
  },
  {
    id: 'article-10',
    slug: 'gpoint-community-guidelines',
    title: 'g点网社区规范与互动指南：共建和谐交流环境',
    excerpt: '了解g点网社区行为规范，学习如何有效参与讨论、发布内容及获取社区积分。',
    content: `<h2>一、社区理念</h2><p>g点网致力于打造一个开放、友善、有价值的社区交流空间。我们鼓励用户分享经验、交流见解，共同建设积极健康的网络环境。</p><h2>二、行为规范</h2><p>社区成员应遵守相互尊重的基本原则，禁止发布违法违规、人身攻击、垃圾广告等内容。对于违规行为，平台将根据情节严重程度给予警告、禁言或封号处理。</p><h2>三、内容发布指南</h2><p>发布内容应确保原创性或已获得合法授权，引用他人作品需注明出处。鼓励发布有深度、有价值的原创内容，优质内容将获得平台推荐和流量扶持。</p><h2>四、积分体系</h2><p>社区积分可通过签到、发布内容、参与互动等方式获取。积分可用于兑换平台会员、专属标识及实物礼品等权益。</p>`,
    categorySlug: 'platform-news',
    author: 'g点网社区团队',
    date: '2026-07-08',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20online%20community%20concept%20with%20connected%20people%20icons%20and%20chat%20bubbles%2C%20warm%20friendly%20atmosphere%2C%20minimalist%20design%2C%20soft%20gradient%20background%2C%20editorial%20style&width=800&height=450&seq=article-community&orientation=landscape',
    tags: ['社区规范', '互动指南', '积分体系'],
    featured: false,
    views: 9800,
  },
  {
    id: 'article-11',
    slug: 'gpoint-data-backup-guide',
    title: 'g点网数据备份与恢复：保护您的重要信息',
    excerpt: '详细教程指导您如何备份g点网账号数据，以及在不同场景下恢复数据的操作方法。',
    content: `<h2>一、数据备份的重要性</h2><p>定期备份数据是防止信息丢失的最佳实践。g点网提供了便捷的数据备份功能，帮助用户保护收藏文章、浏览记录、个人设置等重要数据。</p><h2>二、自动备份设置</h2><p>在个人中心的"数据管理"页面，可开启自动备份功能。系统将按照设定周期自动备份您的核心数据，备份文件加密存储于安全服务器。</p><h2>三、手动备份操作</h2><p>用户也可随时手动触发数据备份。在数据管理页面点击"立即备份"按钮，系统将在几分钟内完成备份并生成备份记录。</p><h2>四、数据恢复流程</h2><p>如需恢复数据，在数据管理页面选择目标备份记录，点击"恢复"即可。恢复操作不会覆盖当前数据，系统会进行智能合并。</p>`,
    categorySlug: 'feature-tutorial',
    author: 'g点网技术团队',
    date: '2026-07-05',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20data%20backup%20concept%20with%20cloud%20storage%20icons%20and%20server%20visualization%2C%20warm%20neutral%20tone%2C%20minimalist%20tech%20design%2C%20professional%20atmosphere%2C%20editorial%20style&width=800&height=450&seq=article-backup&orientation=landscape',
    tags: ['数据备份', '数据恢复', '账号安全'],
    featured: false,
    views: 7200,
  },
  {
    id: 'article-12',
    slug: 'gpoint-payment-issues-faq',
    title: 'g点网付费服务常见问题解答',
    excerpt: '汇总g点网付费会员、虚拟货币及在线支付相关的常见问题与解决方案。',
    content: `<h2>一、付费服务类型</h2><p>g点网提供免费和付费两种服务模式。付费会员可享受去广告、专属内容、优先客服等增值服务，用户可根据需求选择适合的会员方案。</p><h2>二、支付方式</h2><p>平台支持微信支付、支付宝、银联卡等多种支付方式。支付过程采用银行级加密技术，确保交易安全。</p><h2>三、退款政策</h2><p>如对付费服务不满意，可在购买后7天内申请退款。虚拟货币充值原则上不支持退款，请充值前仔细确认金额。</p><h2>四、发票开具</h2><p>如需开具发票，在支付成功页面点击"申请发票"，填写开票信息后，电子发票将在3个工作日内发送至您的注册邮箱。</p>`,
    categorySlug: 'faq',
    author: 'g点网客服团队',
    date: '2026-07-02',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Modern%20online%20payment%20concept%20with%20credit%20card%20and%20mobile%20payment%20icons%2C%20warm%20lighting%2C%20minimalist%20ecommerce%20design%2C%20professional%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=article-payment&orientation=landscape',
    tags: ['付费服务', '支付问题', '会员服务'],
    featured: false,
    views: 11200,
  },
];

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((a) => a.featured);
};

export const getRecentArticles = (limit: number = 6): Article[] => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, limit);
};